import { useTranslation } from '@web_opxp/features';
import findLast from 'lodash/findLast';
import * as React from 'react';
import './UserLevel.scss';
import LevelTitles from './levelTitles.json';

export interface IUserLevelProps {
  level: number;
  session: number;
  cycleLength: number;
}

const UserLevel: React.FC<IUserLevelProps> = ({ level, session, cycleLength }) => {
  const { t } = useTranslation();

  const currentLevel = findLast(LevelTitles, (title) => title.minLevel <= level);
  const levelTitle = currentLevel ? t(currentLevel.title) : '';
  const levelLabel = t('UserLevel.Label', { level });
  const progress = cycleLength === 0 ? 100 : Math.round((session / cycleLength) * 100);
  return (
    <div className="user-level-widget">
      <div className="level-title nn-small">{levelTitle}</div>
      <div className="level-progress">
        <div className="level-progress-bar" data-testid="level-progress-bar" style={{ width: `${progress}%` }} />
      </div>
      <div className="level-label nn-small">{levelLabel}</div>
    </div>
  );
};

export default UserLevel;
